import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "@/constants";
import { PageLoading } from "@/components/atoms";
import { useAuth } from "@/hooks";

interface RequireAuthProps {
  children: React.ReactNode;
}

/**
 * Redirects unauthenticated users to login, preserving intended destination.
 */
export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoading />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.backoffice.login}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};
